<template>
  <PulseModal :open="open" class="w-full md:max-w-[700px]" @close="handleClose">
    <div class="flex flex-col gap-4">
      <div class="text-3xl font-medium">You have unsaved changes</div>
      <div class="text-sm text-typography-disabled">
        If you close without saving your changes, you will lose all of the edits you've made.<br /><br />
        Do you wish to continue and lose all changes made?
      </div>
    </div>
    <template #footer>
      <div class="flex justify-end gap-2">
        <PulseButton variant="secondary" @click="handleClose">Cancel</PulseButton>
        <PulseButton variant="destructive" @click="handleDiscard">Discard Changes</PulseButton>
      </div>
    </template>
  </PulseModal>
</template>

<script setup lang="ts">
const props = defineProps({
  open: {
    default: false,
    type: Boolean,
  },
});
const emit = defineEmits(['close', 'discard']);

function handleClose() {
  emit('close');
}

function handleDiscard() {
  emit('discard');
}
</script>
